module.exports = __webpack_public_path__ + "img/bgR7.aa5190ae.png";